<template>
  <div class="mit-my-borrowed-list pa-5">
    <BaseMitLoading :show="loading" :fullscreen="false"/>
    <v-card flat>
      <v-dialog v-model="dialog" persistent max-width="600px">
        <template v-slot:activator="{ on }">
            <v-btn small v-on="on" class="ma-2" >Generate new API Token</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">Generate API Token</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              Warning! The existing token will be replaced by a new token and any clients using the old token will no longer work!
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog = false">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="generateKey">Ok</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
    <v-card flat>
         <v-card-text>
             <v-text-field label="API Endpoint POST"outlined readonly :value="api"></v-text-field>
             <v-textarea readonly filled no-resize label="API Headers" v-model="apiHeaders"></v-textarea>
             <v-textarea id="mit-api-key" readonly filled no-resize label="API Key" v-model="apiKey"></v-textarea>
             <v-btn outlined rounded @click="copyLink()">Copy Key</v-btn>
             <br><br><br>
             <p><b>Example:</b></p>
             <!-- <v-text-field label="curl example" outlined readonly :value="exampleCurl"></v-text-field> -->
             <v-textarea id="mit-api-curl" filled no-resize readonly label="API Key" v-model="exampleCurl"></v-textarea>
             <v-btn outlined rounded @click="copyCurl()">Copy Curl</v-btn>
        </v-card-text>
    </v-card>

  </div>
</template>

<script>
import moment from 'moment';
import BaseMitConfigService from '../../base/services/BaseMitConfigService.js';
import MitApiKeyService from '../services/MitApiKeyService.js';
import BaseMitLoading from '../../base/components/BaseMitLoading.vue';

export default {
  name: 'MitVolumesList',
  components: {
    BaseMitLoading
  },
  props: {
  },
  data: function() {
    return {
      dialog:false,
      loading:false,
      api:'/api/v1/upload/volumes',
      appUrl:null,
      apiKey:null,
      apiKeyName:'apikey',
      apiHeaders:'"authorization: <<api key>>"\n"Accept: Application/json"\n"Content-Type: application/json"'
      // exampleCurl:"curl -X POST -H 'Authorization: <<api key>>' -H 'Accept: Application/json' -H 'Content-Type: application/json' -d @volume_data.json https://<<domain>>/api/v1/upload/volumes"
    }
  },
  created() {
    this.getApiKey();
  },
  mounted() {
      this.appUrl = BaseMitConfigService.get('SERVER_APP_URI');
  },
  computed: {
    exampleCurl: function() {
        let domain = this.appUrl;
        let key = this.apiKey;
        let path = this.api
      return `curl -X POST -H 'authorization: ${key}' -H 'Accept: Application/json' -H 'Content-Type: application/json' -d @volume_data.json ${domain}${path}`
    }
},
  methods : {
    copyLink(){
        let textarea = document.getElementById("mit-api-key");
        textarea.select();
        document.execCommand("copy");
    },
    copyCurl(){
        let textarea = document.getElementById("mit-api-curl");
        textarea.select();
        document.execCommand("copy");
    },
    getApiKey(){
      this.loading = true;
      MitApiKeyService.requestGetApiKey({name:this.apiKeyName})
        .then((data) => {
          this.loading = false;
          this.apiKey = data.token;
        })
        .catch((error) => {
          this.loading = false;
          console.log('An error occurred trying to get keys list', error);
        });
    },
    generateKey(){
        this.loading = true;
        MitApiKeyService.requestGenerateKey(this.apiKeyName)
          .then((data) => {
            this.loading = false;
            this.dialog = false
            this.apiKey = data.token;
          })
          .catch((error) => {
            this.loading = false;
            this.dialog = false
            console.log('An error occurred trying to get keys list', error);
          });
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
